const makeId = () => `${Date.now()}_${Math.random().toString(36).slice(2)}`;

// Maps the /NotificationLog response shape (subject, htmlContent, notificationType,
// referenceId, isRead, createdDate) to the fields the notification UI reads.
const normalizeNotification = (item) => ({
  ...item,
  id: item.id,
  title: item.subject,
  message: item.htmlContent,
  category: item.notificationType,
  notificationType: item.notificationType,
  referenceId: item.referenceId,
  createdOn: item.createdDate,
  read: item.isRead,
});

const initialState = {
  items: [],
  unreadCount: 0,
};

const Reducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "setNotifications": {
      const items = (actions.payload || []).map(normalizeNotification);
      return {
        ...state,
        items,
        unreadCount: items.filter((it) => !it.read).length,
      };
    }

    case "setUnreadCount":
      return { ...state, unreadCount: actions.payload || 0 };

    case "updateNotification": {
      const updated = normalizeNotification(actions.payload);
      const exists = state.items.some((it) => it.id === updated.id);
      const items = exists
        ? state.items.map((it) =>
            it.id === updated.id ? { ...it, ...updated, read: it.read } : it,
          )
        : [updated, ...state.items];
      return { ...state, items };
    }

    case "addNotification": {
      const id = actions.payload?.id ?? makeId();
      if (state.items.some((it) => it.id === id)) return state;

      return {
        ...state,
        items: [{ id, ...actions.payload, read: false }, ...state.items],
        unreadCount: state.unreadCount + 1,
      };
    }

    case "markNotificationRead": {
      const id = actions.payload;
      const item = state.items.find((it) => it.id === id);
      if (!item || item.read) return state;

      return {
        ...state,
        items: state.items.map((it) => (it.id === id ? { ...it, read: true } : it)),
        unreadCount: Math.max(0, state.unreadCount - 1),
      };
    }

    case "markNotificationsRead":
      return {
        ...state,
        items: state.items.map((it) => ({ ...it, read: true })),
        unreadCount: 0,
      };

    case "clearNotifications":
      return initialState;

    case "logout":
      return initialState;

    default:
      return state;
  }
};

export const notificationReducer = Reducer;
